/* eslint-disable key-spacing */
import React from 'react';
import PropTypes from 'prop-types';
import Label from 'Components/forms/label/Label';

import './ToggleButton.scss';
import { size } from 'Utils/lodashUtils';

const labelFontSpaceStyle = {
  //for less than 5 characters
  fontSize: '12px',
  wordSpacing: '3px',
}

const labelSmallSizeStyle = {
  //for greater than or equal to 6 characters
  fontSize: '9px',
}

const labelDefaultStyle = {
  fontSize: '12px',
}

const labelForLatestStageIndicatorEnabled = {
  fontSize: '12px',
  wordSpacing: '10px',
  backgroundColor: '#005C9E'
}

const labelForLatestStageIndicatorDisabled = {
  fontSize: '12px',
  wordSpacing: '10px',
  backgroundColor: '#9296A5'
}
let styleObject = labelDefaultStyle;
const ToggleButton = ({ id, onChange, isChecked, disabled, offText, onText, row }) => {
  if(size(onText + offText) >= 6)
  styleObject = labelSmallSizeStyle;
  else if(onText == '✔' && isChecked)
  styleObject = labelForLatestStageIndicatorEnabled;
  else if(offText == '✖' && !isChecked)
  styleObject = labelForLatestStageIndicatorDisabled;
  else if(size(onText + offText) < 5)
  styleObject = labelFontSpaceStyle;
  else
    styleObject = labelDefaultStyle;

  return (
    <div className={`switch-button flatsquare ${disabled ? 'disabled' : ''}`}>
     { /*<Label htmlFor={id} labelClass="label-left">{offText}</Label>*/}
      <input
        onChange={row ? () => onChange(row) : onChange}
        checked={isChecked}
        disabled={disabled}
        id={id}
        type="checkbox"
        value="1"
      />
      <label htmlFor={id} data-OnOff={ onText + "    " + offText} style={ styleObject } />
      {/*<Label htmlFor={id} labelClass="label-right">{onText}</Label>*/}
    </div>
  );
};

ToggleButton.propTypes = {
  id: PropTypes.string.isRequired,
  isChecked: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  offText: PropTypes.string,
  onText: PropTypes.string,
};

ToggleButton.defaultProps = {
  id: 'switch',
  disabled: false,
  isChecked: false,
  onChange: () => {},
  offText: 'Off',
  onText: 'On',
};

export default ToggleButton;
